/*
 * @Desc: 城市
 * @Author: lc
 * @Date: 2023-09-26 09:28:06
 * @LastEditors: lc
 * @LastEditTime: 2023-09-27 08:40:54
 */
import request from "@/utils/request";
const city = {
  list (query) {
    return request({
      url: "/city/list",
      method: "get",
      params: query
    });
  },
  // 列表
  select (query) {
    return request({
      url: "/city/select",
      method: "get",
      params: query
    });
  },
  // 编辑
  edit (data) {
    return request({
      url: "/city/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail (data) {
    return request({
      url: "/city/detail",
      method: "post",
      data
    });
  },
  sync (data) {
    return request({
      url: "/city/sync",
      method: "post",
      data
    });
  },
};
export default city;
